import { render, staticRenderFns } from "./followRecords.vue?vue&type=template&id=8d3a4d44&scoped=true"
import script from "./followRecords.vue?vue&type=script&lang=js"
export * from "./followRecords.vue?vue&type=script&lang=js"
import style0 from "./followRecords.vue?vue&type=style&index=0&id=8d3a4d44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d3a4d44",
  null
  
)

export default component.exports